import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import SettingsIcon from '@/shared/assets/icons/sidenav/settings.svg?react';
import TaskIcon from '@/shared/assets/icons/advanced-settings/task.svg?react';
import SphereIcon from '@/shared/assets/icons/advanced-settings/sphere.svg?react';
import ReactionIcon from '@/shared/assets/icons/advanced-settings/reaction.svg?react';
import AudioIcon from '@/shared/assets/icons/advanced-settings/audio.svg?react';
import { ADVANCED_SETTINGS_GROUPS } from '../../../../utils/wizard-helper';

/**
 * Generate Advenced settings groups with group settings data
 */
export const useAdvancedSettingsGroupsData = () => {
  const { selectedProduct } = useSelector(
    (state) => state.createTreatmentWizard,
  );

  return useMemo(
    () =>
      Object.values(
        selectedProduct.variables.reduce((items, variable) => {
          const { group } = variable.ui_configuration;
          const noGroup = 'no group';
          if (group) {
            items[group] = items[group] || {
              groupName: group,
              variables: [],
              Icon: mapGroupsIconst(group),
            };
            items[group].variables.push(variable);
          } else {
            items[noGroup] = items[noGroup] || {
              groupName: '',
              variables: [],
            };
            items[noGroup].variables.push(variable);
          }
          return items;
        }, {}),
      ),
    [selectedProduct],
  );
};

const mapGroupsIconst = (groupName) => {
  switch (groupName) {
    case ADVANCED_SETTINGS_GROUPS.GENERAL:
      return <SettingsIcon className='general' />;
    case ADVANCED_SETTINGS_GROUPS.TASK:
      return <TaskIcon />;
    case ADVANCED_SETTINGS_GROUPS.SPHERE:
      return <SphereIcon />;
    case ADVANCED_SETTINGS_GROUPS.REACTION:
      return <ReactionIcon />;
    case ADVANCED_SETTINGS_GROUPS.AUDIO:
      return <AudioIcon />;
  }
};
